import {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

const STATUS_META = {
  done: { fill: "#10B981", border: "#10B981", label: "Done" },
  at_risk: { fill: "#F97316", border: "#F97316", label: "At risk" },
  upcoming: { fill: "#FFFFFF", border: "#9CA3AF", label: "Upcoming" },
};

export default function MilestoneMarker({ milestone, leftPercent }) {
  const meta = STATUS_META[milestone.status] ?? STATUS_META.upcoming;
  const isAtRisk = milestone.status === "at_risk";

  return (
    <Tooltip delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          data-testid={`milestone-${milestone.id}`}
          data-milestone-status={milestone.status}
          className={cn(
            "absolute top-1/2 -translate-x-1/2 -translate-y-1/2 outline-none",
            isAtRisk && "idea-dot-pulse",
          )}
          style={{ left: `${leftPercent}%` }}
        >
          <span
            aria-hidden
            className="block h-3 w-3 rotate-45 rounded-[2px] border-2 transition-transform hover:scale-110"
            style={{
              backgroundColor: meta.fill,
              borderColor: meta.border,
              boxShadow: isAtRisk
                ? "0 0 0 4px rgba(249,115,22,0.18)"
                : "0 0 0 3px rgba(255,255,255,0.85)",
            }}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent side="top" className="max-w-[220px] bg-zinc-900 text-white">
        <div className="text-[11px] font-bold">{milestone.label}</div>
        <div className="mt-0.5 text-[10px] uppercase tracking-[0.14em] text-white/70">
          Day {milestone.day} · {meta.label}
        </div>
      </TooltipContent>
    </Tooltip>
  );
}
